import HttpClient from "@api/clients/httpClient";
import { Options, Paging, Sorting } from "@api/models/HttpClientModels";
import FoodSideDish from "../models/FoodSideDish";
import FoodSideDishFilter from "../models/FoodSideDishFilter";

const config = {
    endpoint: "food-side-dishes",
};

export default class FoodSideDishService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new FoodSideDishFilter());
    }

    findAsync = async (filter: FoodSideDishFilter, sorting: Sorting, paging: Paging, options: Options, optionalUrl?: string) => {
        return await this.httpClient.findAsync<FoodSideDish[]>(filter, paging, sorting, options, optionalUrl);
    }
}